import { Box } from '@wix/design-system';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

import s from './styles.scss';

export const NotificationWrapper: FC<PropsWithChildren<ReactNode>> = (props) => (
  <Box className={s.floatingNotification}>{props.children}</Box>
);
